import { Avatar, Link, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'

import {
  CampaignArtistRanker,
  CampaignUserRanker,
} from '@/clients/utoniq-core/schema'
import { Rank } from '@/components/organisms'
import { useRouter } from '@/core'
import { Organism } from '@/core/architecture'

type RankingUserDataProps = {
  ranker: CampaignArtistRanker | CampaignUserRanker
  isSolo?: boolean
  onClick?: () => void
}

export const RankingUserData: Organism<RankingUserDataProps> = ({
  ranker,
  isSolo,
  onClick,
}) => {
  const { routerPages, generatePath } = useRouter()
  const url = useMemo(() => {
    if ('artistId' in ranker) {
      return generatePath(routerPages.ArtistTop, {
        artistId: ranker.artistId ?? '#',
      })
    }
    if ('userId' in ranker) {
      return generatePath(routerPages.UserProfile, {
        userId: ranker.userId ?? '#',
      })
    }
    return ''
  }, [generatePath, ranker, routerPages.ArtistTop, routerPages.UserProfile])

  return (
    <Link href={url} onClick={onClick} underline="none">
      <Stack
        direction="row"
        alignItems="center"
        spacing={3}
        sx={{
          ...(isSolo ? { bgcolor: 'grey.100', borderRadius: 1, px: 3 } : {}),
        }}
      >
        <Rank rank={ranker.rank} />
        <Stack
          direction="row"
          flex={1}
          sx={{
            borderBottom: '1px solid',
            borderColor: 'grey.100',
            pb: 3,
            pt: 2,
          }}
          spacing={3}
          alignItems="center"
        >
          <Avatar
            src={ranker.avatar?.smallUri ?? ''}
            sx={{ width: 36, height: 36 }}
          />
          <Stack spacing={1} flex={1}>
            <Typography variant="caption">{ranker.displayName}</Typography>
            <Typography variant="overline" sx={{ textTransform: 'lowercase' }}>
              {ranker.point}pt
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Link>
  )
}
